import React, { memo } from 'react'
import CommonDialog from '../../../../../common/components/dialog/CommonDialog'
import styles from './teammember.module.scss'
import { useDispatch } from 'react-redux'
import { showLoader, hideLoader } from '../../../../../stores/slices/loader-slice'
import { toast } from 'react-toastify'
import { getErrorMessage } from '../../../../../utils/error-handler'
import { UtilityTeamMember } from '../../../../../model/utility-users/utility-team-member'
import {  useResendInviteTeamMemberMutation } from '../../../../../service/utility-users-service'
import Button from '../../../../../common/components/xepp/button/Button'

type Props = {
    user: UtilityTeamMember
    onCloseDialog: () => void
    onResendTeamMemberInvite: () => void
}

const ResendTeamMemberInviteDialog: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch();
    const [resendTeamMemberInvite, { isLoading }] = useResendInviteTeamMemberMutation();
    const handleResendTeamMemberInvite = async () => {
        
        try {
            dispatch(showLoader());
            await resendTeamMemberInvite({
                utilityUserSignUpId : props.user!.id}).unwrap();
            props.onResendTeamMemberInvite();
            toast.success(`You successfully resend invite for user ${props.user!.email} `)
        } catch (error: any) {
            toast.error(getErrorMessage(error.data) ?? 'An Error occurred');
            
        } finally {
            dispatch(hideLoader());
            props.onCloseDialog();
        }
    }

    const cancel = () => {
        props.onCloseDialog();
    }

    return (
        <CommonDialog onCloseDialog={props.onCloseDialog}>
            <div className={`${styles.container} ${styles.DialogContainer}`}>
                <div className={styles.DialogTitle}>
                    Resend Team Member Invite
                </div>
                <div className={styles.DialogBody}>
                    Are you sure you want to resend invite for team member?
                </div>
                <div className={styles.DialogContainerButtons}>
                    <Button text={'No'} variant={`outline`} onClick={cancel} />
                    <Button text={'Yes'}  disabled={isLoading} onClick={handleResendTeamMemberInvite} />
                </div>
            </div>
        </CommonDialog>
    )
})

export default ResendTeamMemberInviteDialog